export default __webpack_public_path__ + "static/media/gymshim-logo.8f9c9ece.png";